import "../../css/page/userList.css";
import { DataGrid, frFR } from "@mui/x-data-grid";
import { Add, DeleteOutline, FolderOpen } from "@material-ui/icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../services/axios";
import { toast } from "react-toastify";
import { LinearProgress } from "@mui/material";
import { endpoint } from "../../utils/API";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import DeleteDialog from "../../components/DeleteDialog/DeleteDialog";
import INFOS from "../../utils/CompanyInfos";
import { calculateAmountDueByClient } from "../../services/Invoices/Invoices.service";

const LIMIT = 10;

const ClientInvoices = () => {
  const { clientId } = useParams();
  const navigate = useNavigate();
  const [infos, setInfos] = useState({ ...INFOS });
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [invoices, setInvoices] = useState([]);
  const [search, setSearch] = useState("");
  const [invoicesCount, setInvoicesCount] = useState(0);
  const [deleteInvoiceID, setDeleteInvoiceID] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const fetchClient = async () => {
    const { data } = await axiosInstance.get(`${endpoint}/clients/${clientId}`);

    if (data) {
      if (!data.success) {
        toast.error(data.message);
        return;
      }

      return data.result;
    }

    return null;
  };

  const fetchClientInvoicesCount = async () => {
    const { data } = await axiosInstance.get(
      `${endpoint}/clients/${clientId}/invoices/count`,
      {
        params: {
          search: search,
          fields: search ? ["infos.structuredCommunication"] : "",
        },
      }
    );

    if (data) {
      if (!data.success) {
        toast.error(data.message);
        return;
      }

      return data.result;
    }

    return 0;
  };

  const fetchClientInvoices = async (page) => {
    const { data } = await axiosInstance.get(
      `${endpoint}/clients/${clientId}/invoices`,
      {
        params: {
          limit: LIMIT,
          offset: !page ? 0 : page * LIMIT,
          search: search,
          fields: search ? ["infos.structuredCommunication"] : "",
        },
      }
    );

    if (data) {
      if (!data.success) {
        toast.error(data.message);
        return;
      }

      return data.result.docs;
    }

    return [];
  };

  useEffect(() => {
    const getClient = async () => {
      const client = await fetchClient();
      setClient(client);
    };

    const getClientInvoicesCount = async () => {
      const count = await fetchClientInvoicesCount();
      setInvoicesCount(count);
    };

    const getClientInvoices = async () => {
      const invoices = await fetchClientInvoices();
      setLoading(false);
      setInvoices(invoices);
    };

    getClient().catch((err) => {
      console.log(err);
    });

    getClientInvoicesCount().catch((err) => {
      console.log(err);
    });

    getClientInvoices().catch((err) => {
      console.log(err);
      setLoading(false);
    });
  }, []);
  const columns = [
    { field: "invoiceNumber", headerName: "N°", width: 80 },
    {
      field: "client",
      headerName: "Client",
      width: 160,
      renderCell: (params) => {
        return (
          <div className="userListUser">
            {/*{params.row.client.image && <img className="userListImg" src={params.row.client.image} alt="" />}*/}
            {params.row.client.firstname} {params.row.client.lastname}
          </div>
        );
      },
    },
    {
      field: "totalWithTaxes",
      headerName: "Montant total (TVAC)",
      width: 180,
      renderCell: (params) => {
        return (
          <div className="userListUser">{params.row.totalWithTaxes} €</div>
        );
      },
    },
    {
      field: "payments",
      headerName: "Paiements",
      width: 200,
      renderCell: (params) => {
        return (
          <div
            className="userListUser"
            style={{ display: "flex", flexDirection: "column" }}
          >
            {params.row.payments.map((payment, index) => (
              <div key={index}>
                {payment.paymentMethod} - {payment.paymentAmount} €
              </div>
            ))}
          </div>
        );
      },
    },
    {
      field: "remaining",
      headerName: "Solde dû",
      width: 100,
      renderCell: (params) => {
        return (
          <div className="userListUser">
            {calculateAmountDueByClient(params.row)} €
          </div>
        );
      },
    },
    {
      field: "infos.structuredCommunication",
      headerName: "Communication structurée",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="userListUser">
            {params.row.infos.structuredCommunication}
          </div>
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Date de création",
      width: 160,
      renderCell: (params) => {
        return (
          <div className="userListUser">
            {new Date(params.row.createdAt).toLocaleDateString()}
          </div>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => {
        return (
          <>
            <Link to={"/invoices/" + params.row._id}>
              <button className="invoiceListEdit">Modifier</button>
            </Link>
            <DeleteOutline
              className="invoiceListDelete"
              data-id={params.row._id}
              onClick={openDeleteDialog}
            />
          </>
        );
      },
    },
  ];

  const handlePageChange = (page) => {
    if (invoices.length <= page * LIMIT) {
      setLoading(true);
      const getInvoices = async () => {
        const nextInvoices = await fetchClientInvoices(page);
        setLoading(false);
        setInvoices((invoices) => [...invoices, ...nextInvoices]);
      };

      getInvoices().catch((err) => {
        console.log(err);
        setLoading(false);
      });
    }
  };

  const onSearchSubmit = (e) => {
    e.preventDefault();

    const getInvoicesCount = async () => {
      const count = await fetchClientInvoicesCount();
      setInvoicesCount(count);
    };

    const getInvoices = async () => {
      const invoices = await fetchClientInvoices();
      setLoading(false);
      setInvoices(invoices);
    };

    getInvoicesCount().catch(() => (err) => {
      console.log(err);
    });

    getInvoices().catch((err) => {
      console.log(err);
      setLoading(false);
    });
  };

  const openDeleteDialog = (e) => {
    e.preventDefault();

    const id = e.currentTarget.dataset.id;

    setDeleteInvoiceID(id);
    setDeleteDialogOpen(true);
  };

  const handleDelete = async () => {
    setLoading(true);

    const { data } = await axiosInstance.delete(
      `${endpoint}/invoices/${deleteInvoiceID}`
    );

    if (data) {
      if (!data.success) {
        toast.error(data.message);

        return;
      }

      toast.success("Facture supprimée avec succès !");

      const invoices = await fetchClientInvoices();
      setInvoices(invoices);
    }

    setLoading(false);
  };

  const addNewInvoice = async () => {
    if (!client._id || client._id === "") {
      toast.error("Veuillez sélectionner un client !");

      return;
    }

    await axiosInstance
      .post(`${endpoint}/invoices`, {
        client: client,
        products: [],
        infos: infos,
        payments: [],
        comments: [],
      })
      .then((response) => {
        if (response.data.success) {
          const { _id } = response.data.result;

          toast.success("Facture créée avec succès !");
          navigate(`/invoices/${_id}`);

          return;
        }

        toast.error(response.data.message);
      })
      .catch(() =>
        toast.error(
          "Une erreur est survenue lors de la création de la facture !"
        )
      );
  };

  const onSearchChange = (e) => {
    setSearch(e.target.value);
  };

  return (
    <>
      <div className="content">
        <div className="above-table">
          <div className="title-search-container">
            <div className="title">
              {client?.clientNumber} - {client?.firstname} {client?.lastname}
            </div>
            <form onSubmit={onSearchSubmit}>
              <TextField
                id="search-bar"
                style={{ width: 258 }}
                label="Communication structurée"
                variant="outlined"
                size="small"
                type="text"
                name="search"
                value={search}
                onChange={onSearchChange}
              />
              <IconButton type="submit" aria-label="search">
                <SearchIcon style={{ fill: "#E4221D" }} />
              </IconButton>
            </form>
          </div>

          <div className="create-button" onClick={addNewInvoice}>
            <div className="create-button-icons">
              <Add />
              <FolderOpen />
            </div>

            <span>Facture</span>
          </div>
        </div>

        <DataGrid
          rows={invoices}
          components={{
            LoadingOverlay: LinearProgress,
          }}
          loading={loading}
          getRowId={(row) => row._id}
          disableSelectionOnClick
          columns={columns}
          pageSize={LIMIT}
          rowsPerPageOptions={[LIMIT]}
          rowCount={invoicesCount}
          localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
          onPageChange={handlePageChange}
        />
      </div>

      <DeleteDialog
        handleDelete={handleDelete}
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
      />
    </>
  );
};

export default ClientInvoices;
